export interface IAutoBreakItem {
    BreakName: string
    BreakDurationInMinutes: number
    BreakTriggerDurationInMinutes: number
    ApplyRule: EAutoBreakApplyRule
    OneTimeApply: boolean
    OneTimeApplyPerDay: boolean
    OneTimeApplyPerDayByTotalHours: boolean
    TimeDurationRule: EAutoBreakTimeDurationApplyRule
    ExcludePayTypeIds: string[]
}

export enum EAutoBreakApplyRule {
    PunchHierarchy,
    EmployeeDefaultHierarchy,
}

export enum EAutoBreakTimeDurationApplyRule {
    ActualTime,
    RoundedTime
}